<template>
  <div class="container">
    <div class="row text--base">
      <StackedBarChart v-if="stackedbarTitle" :content="stackedbarTitle" />
    </div>
  </div>
</template>

<script>
import { json as fetchJson } from 'd3';
import StackedBarChart from '@/components/content/chapter2/StackedBarChart.vue';

export default {
  name: 'App5StackedBar',
  components: {
    StackedBarChart,
  },
  data() {
    return {
      content: {},
    };
  },
  computed: {
    stackedbarTitle() {
      return this.content.sections ? this.content.sections.find((d) => d.id === 'stacked-bar-chart') : {};
    },
  },
  async created() {
    this.content = await fetchJson(`${process.env.BASE_URL}data/content/chapter-02.json`);
  }
};
</script>